import { css } from 'twin.macro';

export const boxShadow = css`
  box-shadow: 0 5px 30px -15px rgba(0, 0, 0, 0.2);
`;
